import React, { useState } from 'react';
import { Send, Loader } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const Newsletter = ({ t }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !(Array.isArray(email) ? email : []).includes('@')) {
      setStatus('error');
      setTimeout(() => setStatus(''), 3000);
      return;
    }
    setLoading(true);
    setStatus('');
    try {
      const res = await fetch(`${BACKEND_URL}/api/homepage/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(''), 5000);
    }
  };

  return (
    <div className="newsletter-section">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-info">
            <h3 className="heading-2">{t.newsletter.title}</h3>
            <p className="body-medium text-secondary">{t.newsletter.subtitle}</p>
          </div>
          
          <form onSubmit={handleSubmit} className="newsletter-form" data-testid="newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.newsletter.placeholder}
              className="newsletter-input"
              required
              data-testid="newsletter-email-input"
            />
            <button type="submit" className="btn-primary" disabled={loading} data-testid="newsletter-submit-btn">
              {loading ? <Loader size={16} className="spin" /> : <Send size={16} />}
              {t.newsletter.button}
            </button>
          </form>
          
          {status === 'success' && (
            <div className="newsletter-success body-small" data-testid="newsletter-success-msg">{t.newsletter.success}</div>
          )}
          {status === 'error' && (
            <div className="newsletter-error body-small" data-testid="newsletter-error-msg">{t.newsletter.error}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
